import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './Terms.css';
import NeighbourSidebar from "../../NeighbourSidebar";
import Header from "../../NeighbourHeaderAfterLogin";
import Footer from "../../FooterAfterLogin";
import loader from '../../../assests/loader.gif';
import API from '../../../Utils/Api';
import Image from 'react-bootstrap/Image';
import { Link,useNavigate } from 'react-router-dom';

const Terms = () => {
    const navigate = useNavigate();
    const [loading,setLoading] = useState(true);
    const [terms, setTerms] = useState('<p></p>');
    const [img, setImg] = useState('');
    useEffect(() => {
        document.title = `Terms & Conditions | Local Bells`;
        document.getElementById('bodywrap').className = 'neterms';

        /* Start get terms */
        let formData = new FormData();
        formData.append('type', 'terms');
            API.post('get_page', formData)
                .then(response => {
                    setLoading(false);
                if(response.data.status === false){
                    
                }else{
                  setImg(response.data.data.image);
                  setTerms(response.data.data.content);
                }                  
            }).catch(error => {
                 
            });  
        /* End get terms */

    }, []);

    // State to toggle sidebar visibility
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    // Function to toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarVisible((prev) => !prev);
    };

    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <NeighbourSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />
                            <div className='nei-cont'>
                                <div className='white-box static-cont'>
                                    <Row>
                                        <Col>
                                            <div className="d-flex align-items-start justify-content-between gap-3">
                                                <h3>Terms & Conditions</h3>
                                                <Link to="#" onClick={() => navigate(-1)} className='cross-up'>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/cross.webp'} className="img-fluid crosy" alt="wp" />
                                                </Link>
                                            </div>
                                            
                                        </Col>
                                    </Row>
                                    <Row className=''>
                                        {img && (
                                        <Col xs={12} className="mb-4">
                                                <Image
                                                  src={img}
                                                  className="img-fluid "
                                                  alt="wp"
                                                />
                                        </Col>
                                        )}
                                        <Col xs={12}>
                                            <div dangerouslySetInnerHTML={{__html: terms}} />
                                        </Col>
                                    </Row>
                                </div>
                                <div className='footer-main footer'>
                                    <Footer />                                
                                </div>                                    
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            {loading && (
               <div className="loadingClass">
                <img src={loader} alt="loader"/>
              </div>
            )}  
        </>
    )
}

export default Terms;


